import { Button } from "@mantine/core";
import { Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

interface BackLinkProps {
  to: string;
  label?: string;
}

export function BackLink({ to, label }: BackLinkProps) {
  const { t } = useTranslation();

  return (
    <Button
      variant="subtle"
      leftSection={<ArrowLeft size={16} />}
      component={Link}
      to={to}
      w="fit-content"
    >
      {label ?? t("common.back")}
    </Button>
  );
}
